import styled, { css } from 'styled-components';

import Button from '~/src/common/components/Button';
import RichText from '~/src/common/components/CMS/RichText';
import Link from '~/src/common/components/Link';
import { Waves } from '~/src/common/components/Logo';
import { ModalContent as BaseModalContent } from '~/src/common/components/Modal/layout';
import { H3styles, TextStyles } from '~/src/common/components/Typography';
import { media } from '~/src/styles-constants';

export const Title = styled.h1`
  margin-bottom: 32px;

  color: ${({ theme }) => theme.palette.common.TEXTS};
  font-size: 24px;
  font-weight: 700;
  font-family: ${({ theme }) => theme.fonts.secondary};
  line-height: 32px;
  text-align: center;

  ${media.S`
    font-size: 32px;
  `}
`;

export const Container = styled.div`
  position: relative;
  padding: 0;
  margin: 0;
  max-width: 1308px;
  ${media.M`
    margin: auto;
  `}
`;

const contentStyle = css`
  justify-content: flex-start;
  align-items: stretch;
  top: 0;
  padding: 32px 16px;
  ${media.S`
    padding: 32px 64px 64px;
  `}
`;

export const PageContent = styled.div`
  ${contentStyle}
`;

export const ModalContent = styled(BaseModalContent)`
  ${contentStyle}
`;

export const StyledWaves = styled(Waves)`
  width: 100%;
  min-height: 12px;
  margin-bottom: 32px;
`;

export const Image = styled.img<{ withBorderRadius: boolean }>`
  width: 100%;

  ${media.XL<{ withBorderRadius: boolean }>`
    height: 100%;
  border-radius: ${({ withBorderRadius }) => (withBorderRadius ? '8px 8px 0 0' : '0')};
    
  `}
`;

export const TextContent = styled(RichText)`
  > h2 > span {
    color: ${({ theme }) => theme.palette.common.TEXTS};
    font-size: 20px;
    font-weight: 700;
    font-family: ${({ theme }) => theme.fonts.secondary};
    line-height: 28px;
  }

  > h3 > span {
    ${H3styles}
  }

  > p {
    ${TextStyles}
  }
`;

export const GoBackLink = styled(Link)`
  display: flex;
  margin-bottom: 8px;
  margin-top: 16px;
`;
export const GoBackSpan = styled.span`
  margin-left: 6px;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
`;

export const MobileCloseButton = styled(Button)`
  position: fixed;
  right: 10px;
  top: 10px;
  z-index: 1;
  padding: 0 1px 3px 0;
  border: none;
  background-color: ${({ theme }) => theme.palette.common.WHITE};
  color: ${({ theme }) => theme.palette.primary};
`;
